/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfSecurityQuestions } from '../../models/data-page-of-security-questions';

export interface SecurityQuestionGetSecurityQuestion2$Params {
  Username?: string | null;
  uName: string;
}

export function securityQuestionGetSecurityQuestion2(http: HttpClient, rootUrl: string, params: SecurityQuestionGetSecurityQuestion2$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfSecurityQuestions>> {
  const rb = new RequestBuilder(rootUrl, securityQuestionGetSecurityQuestion2.PATH, 'get');
  if (params) {
    rb.query('Username', params.Username, {});
    rb.path('uName', params.uName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfSecurityQuestions>;
    })
  );
}

securityQuestionGetSecurityQuestion2.PATH = '/api/SecurityQuestion/{uName}';
